import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

// Mock Provider for non-ExoSkeleton environments (otherwise ReferencePicker will not render at all)
const CorrNonExoMockProvider: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default CorrNonExoMockProvider;
